// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"36":"fb135bf0","120":"f7e847b1","201":"d180482d","324":"5415c55b","500":"fa1e16fe","878":"11024c49","986":"f03bc20c"}[chunkId] + ".css";
};